// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"book"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M20.5 2.5H6.5C4.84315 2.5 3.5 3.84315 3.5 5.5V18.5C3.5 16.8431 4.84315 15.5 6.5 15.5H20.5V2.5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M20.5 21.5H6.5C4.84315 21.5 3.5 20.1569 3.5 18.5C3.5 16.8431 4.84315 15.5 6.5 15.5H20.5V21.5ZM20.5 21.5V2.5H6.5C4.84315 2.5 3.5 3.84315 3.5 5.5V17.5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M11.5 6.5H16.5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-book')
export default class BookIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'book',
    }
  }
}
